@if (config) {
  <div class="highlight">
    <div class="chart">
      @for (item of elements; track item) {
        <div class="element">
          <div class="chartAmount" [id]="item.id"></div>
        </div>
      }
      <div class="labels">
        <div class="data">
          <span class="dot" [style.--color]="metadata.differenceColor"></span>
          <span class="label">{{ metadata.differenceLabel }} </span>
        </div>
        <div class="data">
          <span class="dot" [style.--color]="metadata.baseColor"></span>
          <span class="label">{{ metadata.baseLabel }}</span>
        </div>
      </div>
    </div>
  </div>
}